import * as React from 'react';

import { HeroBentoModule } from '@coursera-web/cds-labs';

import CampaignHeroModuleRenderer, {
  useShouldShowCampaignHeroModule,
} from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer';
import SeoPageHeader from 'bundles/front-page/components/modules/hero-banner/SeoPageHeader';
import { useFrontPageRedesignQ32025Data } from 'bundles/front-page/providers/FrontPageRedesignQ32025Provider';
import getPredefinedPromos from 'bundles/front-page/redesign-modules/hero-banner/data/getPredefinedPromos';

const HeroBannerSliderModuleRenderer = () => {
  const shouldShowCampaignHeroModule = useShouldShowCampaignHeroModule();
  const { enableFrontPageRedesignHeroCTAOptimization } = useFrontPageRedesignQ32025Data();

  let heroModuleOutput;

  if (shouldShowCampaignHeroModule) {
    heroModuleOutput = (
      <CampaignHeroModuleRenderer showOptimizedHeroBentoModule={enableFrontPageRedesignHeroCTAOptimization} />
    );
  } else {
    const defaultCards = getPredefinedPromos();
    const cards = [defaultCards.joinForFree, defaultCards.c4b, defaultCards.promoCert];

    heroModuleOutput = <HeroBentoModule cards={cards} showOptimization={enableFrontPageRedesignHeroCTAOptimization} />;
  }

  return (
    <div data-testid="front-page-hero-banner-module">
      <SeoPageHeader />
      {heroModuleOutput}
    </div>
  );
};

export default HeroBannerSliderModuleRenderer;
